/**
 * «كمّل ملفك» — the home screen's card (المرحلة 1.2, P01; the «Update
 * profile» card of the second screen in the brief).
 *
 * The server's percentage and the next open step, with one button straight to
 * it. Shown while the profile is not complete; once it is, a slim line keeps
 * the way back to «ملفي الصحي». Only a patient's own account has a profile, so
 * the admin, who sees these screens too, is not asked.
 */

import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Icon } from '../../components/common';
import { healthProfileApi } from '../../api/endpoints';
import { ROLES, useAuth } from '../../context/AuthContext';
import { useI18n } from '../../i18n/I18nProvider';
import { STEP_ICONS } from './HealthOnboardingWizard';

export function HealthProfileCard() {
  const { t } = useI18n();
  const { session } = useAuth();
  const [state, setState] = useState(null);
  const own = session && (session.role === ROLES.PATIENT || session.role === ROLES.TEAM_MEMBER);

  useEffect(() => {
    if (!own) return undefined;
    let cancelled = false;
    healthProfileApi
      .get()
      .then((answer) => !cancelled && setState(answer))
      .catch((err) => console.warn('[health-profile] The card could not load:', err.message));
    return () => {
      cancelled = true;
    };
  }, [own]);

  if (!own || !state) return null;

  if (state.completeness >= 100) {
    return (
      <Link to="/patient/health-profile" className="hp-home hp-home--done" data-testid="hp-home-card">
        <Icon name="check-circle-2" size={18} />
        <span>{t('healthProfile.home.complete')}</span>
      </Link>
    );
  }

  const next = state.next;
  const left = state.steps.filter((s) => !s.done).length;
  return (
    <section className="hp-home" data-testid="hp-home-card" aria-label={t('healthProfile.home.title')}>
      <div className="hp-home__ring" style={{ '--hp-pct': `${state.completeness}%` }}>
        <span>{state.completeness}%</span>
      </div>
      <div className="hp-home__body">
        <h3>{t('healthProfile.home.title')}</h3>
        <p>{state.missing.length ? t('healthProfile.home.required', { n: state.missing.length }) : t(left === 1 ? 'healthProfile.home.leftOne' : left === 2 ? 'healthProfile.home.leftTwo' : 'healthProfile.home.left', { n: left })}</p>
        {next && (
          <p className="hp-home__next">
            <Icon name={STEP_ICONS[next]} size={14} /> {t('healthProfile.home.next', { step: t(`healthProfile.steps.${next}`) })}
          </p>
        )}
      </div>
      <Link to={next ? `/patient/health-profile?step=${next}` : '/patient/health-profile'} className="btn-primary hp-home__go" data-testid="hp-home-go">
        {t('healthProfile.home.go')}
        <Icon name="chevron-left" size={16} className="flip-ltr" />
      </Link>
    </section>
  );
}

export default HealthProfileCard;
